import React from 'react';
import { getImageUrl } from '../../services/api';

type BrandLogoSize = 'sm' | 'md' | 'lg' | 'xl';

interface BrandLogoProps {
  logoUrl?: string | null;
  platformName?: string | null;
  size?: BrandLogoSize;
  className?: string;
  imageClassName?: string;
}

const sizeClasses: Record<BrandLogoSize, string> = {
  sm: 'h-11 w-11',
  md: 'h-14 w-14',
  lg: 'h-20 w-20',
  xl: 'h-24 w-24',
};

const BrandLogo: React.FC<BrandLogoProps> = ({
  logoUrl,
  platformName,
  size = 'md',
  className = '',
  imageClassName = '',
}) => {
  const src = getImageUrl(logoUrl);
  const alt = platformName ? `${platformName} logo` : 'Platform logo';

  if (!src) {
    return null;
  }

  return (
    <span className={`inline-flex items-center justify-center flex-shrink-0 ${sizeClasses[size]} ${className}`}>
      <img
        src={src}
        alt={alt}
        className={`h-full w-full object-contain ${imageClassName}`}
      />
    </span>
  );
};

export default BrandLogo;
